import { put } from 'redux-saga/effects'
import { fetchContactsByCompanyAction } from '../../handles'
import { fetchContactsByCompany } from '../_http/contact'

export function* fetchContactsByCompanySaga(action: ReturnType<typeof fetchContactsByCompanyAction.request>) {
  try {
    const { companyId, ownerId } = action.payload
    const response = yield fetchContactsByCompany({ companyId, ownerId })
    yield put(fetchContactsByCompanyAction.success({ contacts: response.contacts }))
  } catch (error) {
    yield put(fetchContactsByCompanyAction.failure())
  }
}
